import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import {
  createScaffolderFieldExtension,
  type FieldExtensionOptions,
} from '@backstage/plugin-scaffolder-react';
import { StarterPicker } from './StarterPickerExtension';

// Exported as plain options as well as a provided extension. The stock /create
// route registers the extension as a React child; anything rendering a
// template outside that route needs the options (see ../extensions.ts).
export const starterPickerFieldOptions: FieldExtensionOptions<any, any> = {
  name: 'StarterPicker',
  component: StarterPicker,
};

export const StarterPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension(starterPickerFieldOptions),
);
